import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { ref: "paypalButton" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-exclamation-triangle me-1" }, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "my-5 text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center text-success mt-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-square-o fa-4x" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h3 ps-3" }, "Bezahlung erfolgreich")
], -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, null, 512),
      (_ctx.paypalError)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            type: "danger"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.paypalError), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.paypalLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !_ctx.paypalSuccess]
    ]),
    _withDirectives(_createElementVNode("div", null, _hoisted_7, 512), [
      [_vShow, _ctx.paypalSuccess]
    ])
  ], 64))
}